//src/rtkQuery/features/services/testimonials/testimonialApi.slice.ts

import { baseApi } from '@/rtkQuery/features/services/baseApi';
import { TESTIMONIAL_ENDPOINTS } from '@/rtkQuery/config/testimonialApi.config';
import { buildQuery } from '@/rtkQuery/lib';
import type {
  Testimonial,
  SubmitTestimonialRequest,
  SubmitTestimonialResponse,
} from '@/rtkQuery/features/models/testimonial.model';

const testimonialApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTestimonials: builder.query<Testimonial[], void>({
      query: buildQuery(TESTIMONIAL_ENDPOINTS.GET_ALL, 'GET'),
      transformResponse: (response: Testimonial[], meta) => {
        (meta as any).status = 'success';
        (meta as any).error = null;
        return response;
      },
      transformErrorResponse: (response: any, meta) => {
        const errorMessage = response.data?.message || 'Failed to fetch testimonials';
        (meta as any).status = 'error';
        (meta as any).error = errorMessage;

        return {
          status: response.status,
          message: errorMessage,
          errors: response.data?.errors || {},
        };
      },
      providesTags: ['Testimonials'],
    }),

    submitTestimonial: builder.mutation<SubmitTestimonialResponse, SubmitTestimonialRequest>({
      query: buildQuery(TESTIMONIAL_ENDPOINTS.SUBMIT, 'POST'),
      invalidatesTags: ['Testimonials'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTestimonialsQuery,
  useLazyGetTestimonialsQuery,
  useSubmitTestimonialMutation,
} = testimonialApi;